import { useSelector } from 'react-redux';

const selectActiveDialog = (state) => state.ui.dialogs[0];

export function useActiveDialog() {
    return useSelector(selectActiveDialog);
}
